import type React from 'react';

import type { RedditPostComponentsProps } from './types';

export const Footer: React.FC<RedditPostComponentsProps> = (_props) => {
	return null;
};
